<template>
    <div>
        <el-dialog title="Zdjęcia"
                   append-to-body
                   class="photos-dialog"
                   :before-close="handleClose"
                   width="80vw"
                   :visible.sync="dialogFormVisible">
            <el-form :inline="true" @submit.prevent.native="searchData">
                <el-form-item class="list__search-wrapper">
                    <el-input class="list__search" v-model="search"
                              placeholder="Nazwa"></el-input>
                </el-form-item>
                <el-form-item class="list__search-wrapper">
                    <el-button @click="searchData">{{ $t('search') }}</el-button>
                </el-form-item>
            </el-form>

            <div class="list" v-loading="loading">
                <el-card shadow="hover"
                         :body-style="{ padding: '0px' }"
                         class="item"
                         :key="`${photo.photo}_${photo.name_pl}_${photo.title_pl}`"
                         v-for="photo in photos">
                    <div @click="submitPhoto(photo.photo)">
                        <img class="item__img" :src="photo.photo" alt="">
                        <p class="item__text" v-if="photo.name_pl || photo.title_pl">
                            {{ truncate(photo.name_pl || photo.title_pl) }}
                        </p>
                    </div>
                </el-card>
            </div>

            <el-col :span="24" class="list__pagination">
                <el-pagination layout="prev, pager, next"
                               :disabled="loading"
                               @current-change="handlePageChange"
                               :page-size="pageSize" :total="count">
                </el-pagination>
            </el-col>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelForm()">Anuluj</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {Image} from '@/api'

    export default {
        props: ["bus"],
        data () {
            return {
                photos: {},
                dialogFormVisible: false,
                page: 1,
                search: '',
                pageSize: 10,
                count: 0,
                loading: false
            }
        },
        watch: {
            dialogFormVisible (value) {
                if (value) {
                    this.resetFilters()
                    this.fetchData()
                }
            }
        },
        mounted () {
            this.bus.$on('openPhotosDialog', this.openDialog)

        },
        methods: {
            resetFilters () {
                this.search = ''
                this.page = 1
            },
            searchData () {
                this.page = 1
                this.fetchData()
            },
            fetchData () {
                const filters = {
                    q: this.search,
                    page: this.page
                }
                this.loading = true
                this.photos = []
                Image.all(filters).then(response => {
                    this.photos = response.data.results
                    this.pageSize = response.data.page_size
                    this.count = response.data.count
                    this.loading = false
                })
            },
            openDialog () {
                this.dialogFormVisible = true
            },
            handleClose (done) {
                this.dialogFormVisible = false
            },
            cancelForm () {
                this.dialogFormVisible = false
                this.$emit('cancel')
            },
            submitPhoto (photo) {
                this.$emit('submit', photo)
                this.dialogFormVisible = false
            },
            handlePageChange (value) {
                this.page = value;
                this.fetchData();
            },
            truncate (text) {
                if (text) {
                    return text.slice(0, 20)
                }
                return ''
            }
        }
    }
</script>
<style lang="scss" scoped>
    .list {
        grid-gap: 20px 20px;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
    }

    .item {
        cursor: pointer;
        width: 150px;
        text-align: center;
        display: grid;
        align-items: center;
        transition: all .3s;
        &__img {
            max-width: 100%;
        }
        &__text {
            margin: 0;
            color: #999;
            font-size: 13px;
        }
        &:hover {
            transform: scale(1.05);
            border-color: #a9a9a9;
        }
    }

    .photos-dialog {
        z-index: 775666 !important;
    }

</style>


// WEBPACK FOOTER //
// PhotosDialog.vue?d6995198